import * as constants from './constants';

export const initialState = {
  loading: false,
  data: [],
  ids: [],
  suggestions: [],
  error: null,
};

export const tagsReducer = (state = initialState, action) => {
  switch (action.type) {
  case constants.GET_TAGS:
    return { ...state, loading: true };
  case constants.SET_TAGS: {
    const intersection = new Set([...state.ids, ...action.payload.map(({ id }) => id)]);

    return {
      ...state,
      data: [...state.data, ...action.payload.filter(({ id }) => !state.ids.includes(id))],
      ids: [...Array.from(intersection)],
    };
  }
  case constants.GET_TAGS_SUCCESS: {
    const intersection = new Set([...state.ids, ...action.payload.map(({ id }) => id)]);

    return {
      ...state,
      loading: false,
      data: [...state.data, ...action.payload.filter(({ id }) => !state.ids.includes(id))],
      ids: [...Array.from(intersection)],
      suggestions: action.payload,
    };
  }
  case constants.GET_TAGS_ERROR:
    return { ...state, loading: false, error: action.payload };
  case constants.RESET_TAGS:
    return initialState;
  default:
    return state;
  }
};
